import { render, staticRenderFns } from "./ExpertForum.vue?vue&type=template&id=f7e80b50&scoped=true&"
import script from "./ExpertForum.vue?vue&type=script&lang=js&"
export * from "./ExpertForum.vue?vue&type=script&lang=js&"
import style0 from "./ExpertForum.vue?vue&type=style&index=0&id=f7e80b50&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e80b50",
  null
  
)

export default component.exports